import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

$(function() {

    var mySwiper = new Swiper('.swiper-container', {
        modules: [Navigation],
        slidesPerView: 'auto',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });

    $('.news-label').on('click', function() {
        $(this).parents('.news-collapse').find('.news-list').slideToggle(300);
    });

    function initialize() {
        var $map = $('#map');

        if(!$map.length) {
            return;
        }

        var latlng = new google.maps.LatLng($map.data('lat'), $map.data('lng'));

        var mapOptions = {
            center: new google.maps.LatLng($map.data('lat') + 0.025, $map.data('lng')),
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            draggable: false,
            disableDefaultUI: true
        };
        var map = new google.maps.Map($map.get(0), mapOptions);

        var marker = new google.maps.Marker({
            map: map,
            icon: 'images/gm-marker.png',
            title: 'Test',
            position: latlng
        });

        var infowindow = new google.maps.InfoWindow({
            content: $('.infowindow').prop('outerHTML'),
            maxWidth: 272
        });

        infowindow.open(map, marker);

        google.maps.event.addListener(infowindow, 'domready', function(){
            $(".gm-style-iw").next("div").hide();
            $('.gm-style-iw').prev().children().eq(0).hide();
            $('.gm-style-iw').prev().children().eq(1).hide();
            $('.gm-style-iw').prev().children().eq(2).find('> div > div').css('box-shadow', '');
        });
    }

    google.maps.event.addDomListener(window, 'load', initialize);

    $('.letter-nav:not(.disabled)').on('click', function () {
        $('.letter-collection, .letter-nav').removeClass('active');
        $(this).addClass('active');
        $('#letter-collection-' + $(this).data('letter')).addClass('active');
    });

    $('.input:not(.dropdown) input, .input textarea').on('focus', function() {
        $(this).parent().addClass('focus');
    }).on('blur', function() {
        $(this).parent().toggleClass('has-value', !!$(this).val());

        if($(this).is(':valid')) {
            $(this).parent().addClass('check');
            $(this).parent().removeClass('error');
        } else {
            $(this).parent().removeClass('check');
        }

        $(this).parent().removeClass('focus');
    }).on('keyup', function () {
        $(this).parent().toggleClass('valid', !!$(this).is(':valid'));
    }).on('mouseenter', function() {
        $(this).parent().addClass('hover');
    }).on('mouseleave', function() {
        $(this).parent().removeClass('hover');
    });

    $('.input.dropdown').on('mouseenter', function () {
        $(this).addClass('focus');
    }).on('mouseleave', function () {
        $(this).removeClass('focus');
    });

    $('.input.dropdown > ul').on('mouseenter', function () {
        $(this).parent().addClass('focus');
    }).on('mouseleave', function () {
        $(this).parent().removeClass('focus');
    });

    $('.input.dropdown input').on('change', function() {
        var $input = $(this).closest('.input');
        $input.find(' > span').html($(this).val());
        $input.addClass('has-value');
        $input.removeClass('error');
    });

    var changed = false;
    var submit = false;

    $('form.signup').attr('novalidate', '').on('submit', function(e) {
        submit = true;
        $(this).find('input[required], textarea[required]').each(function() {
            if(!$(this).is(':valid')) {
                $(this).closest('.input').addClass('error');
                e.preventDefault();
                submit = false;
            } else {
                $(this).closest('.input').removeClass('error');
            }
        });
    }).find('input, select, textarea').on('input change', function () {
        changed = true;
    });

    window.onbeforeunload = function() {
        if(changed && !submit) {
            return "Weet u zeker dat u de pagina wilt verlaten? Ingevulde velden zullen worden gewist."
        }
    };

    function search() {
        var $search_input = $(this).closest('.search').find('input');
        location.href = [$search_input.data('target'), $.param({
            q: $search_input.val()
        })].join('?');
    }

    var searches = $('nav, #mmenu');

    searches.find('.search input').on('keyup', function (e) {
        if(e.keyCode == 13) {
            search.call(this);
        }
    });

    searches.find('.search button').on('click', search);

    $('.signup [placeholder]').each(function () {
        var $this = $(this);
        $this.before($('<label>', {
            html: $this.attr('placeholder')
        }));
    }).attr('placeholder', null);

    $('.signup .input.dropdown > span').each(function () {
        var $this = $(this);
        $this.before($('<label>', {
            html: $this.html()
        }));
    }).html('&nbsp;');

    function fixHeights(selector) {
        var maxHeight = 0;

        $(selector).css('min-height', 0);

        $(selector).each(function() {
            if($(this).innerHeight() > maxHeight) {
                maxHeight = $(this).innerHeight();
            }
        });

        $(selector).css('min-height', maxHeight);
    }

    function fix() {
        fixHeights('.home-news .news-item .title');
        fixHeights('.home-news .news-item .smalltext:not(.readmore)');
    } fix();
    $(window).on('resize', fix);

    //$('input.date').inputmask({
    //    mask: '99-99-9999',
    //    'placeholder': ' '
    //});

    var lastScrollTop = 0;
    $(window).on('scroll', function(event) {
        var st = $(this).scrollTop();
        if($(this).width() > 1024) {
            return;
        }
        if (st > lastScrollTop){
            if(st > 50) {
                $('body').addClass('no-nav');
                setTimeout(function () {
                    $('nav').hide();
                }, 300);
            }
        } else {
            $('nav').fadeIn(0, function () {
                $('body').removeClass('no-nav');
            });
        }
        lastScrollTop = st;
    });
});

$(function() {
    $("#mmenu").mmenu({
        offCanvas: {
            position  : "right",
            zposition: "next"
        },
        navbar: false
    });
});